module.exports = __webpack_public_path__ + "static/media/profile.0935041e.md";